// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__QY1Md","actionsCol":"EnrolledClinics_actionsCol__bdZP8"};